import { render, staticRenderFns } from "./ADdDeliveryBoy.vue?vue&type=template&id=673b5c66&"
import script from "./ADdDeliveryBoy.vue?vue&type=script&lang=js&"
export * from "./ADdDeliveryBoy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports